import { Route, Routes, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from './api/client';
import LoginPage from './routes/Login';
import DashboardPage from './routes/Dashboard';
import ProductsPage from './routes/Products';
import ProductDetailPage from './routes/ProductDetail';
import JobsPage from './routes/Jobs';
import RepricePage from './routes/Reprice';
import CompositesPage from './routes/Composites';
import BulkAdjustPage from './routes/BulkAdjust';
import AnalyzePage from './routes/Analyze';
import IncomePage from './routes/Income';
import OrdersPage from './routes/Orders';
import SettingsPage from './routes/Settings';
import Layout from './components/Layout';

export default function App() {
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me(), retry: false });

  if (me.isLoading) {
    return <div className="min-h-screen grid place-items-center text-slate-500">로딩...</div>;
  }

  if (!me.data) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:id" element={<ProductDetailPage />} />
        <Route path="/analyze" element={<AnalyzePage />} />
        <Route path="/income" element={<IncomePage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/reprice" element={<RepricePage />} />
        <Route path="/bulk-adjust" element={<BulkAdjustPage />} />
        <Route path="/composites" element={<CompositesPage />} />
        <Route path="/logs" element={<Navigate to="/jobs" replace />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
